module.exports = __webpack_public_path__ + "media/Audio19_i.92d308cf.wav";